const norm = (v) => (v ?? "").toString().trim().toLowerCase();

export function colorForResult(result) {
  const r = norm(result);
  if (r === "approved") return "green";
  if (r === "refer") return "yellow";
  if (r === "referred") return "yellow";
  if (r === "resubmission") return "purple";
  if (r === "declined") return "red";
  if (r === "action") return "red";
  if (r === "action required") return "crimson";
  if (r === "processing") return "orange";
  return "blue";
}
